import React, { useState } from "react";
import { LeagueContext } from "./LeagueContext";

const LeagueContextProvider = ({ children }) => {
  const [leagueCode, setLeagueCode] = useState("");
  const [checkboxCheckedStates, setCheckboxCheckedStates] = useState([]);
  const [
    triggerClassicPublicLeagueRefetch,
    setTriggerClassicPublicLeagueRefetch,
  ] = useState(false);
  const [isLeagueMarketingPage, setIsLeagueMarketingPage] = useState(false);
  const [leagueInfoSuccessData, setLeagueInfoSuccessData] = useState({});

  const value = {
    leagueCode,
    checkboxCheckedStates,
    triggerClassicPublicLeagueRefetch,
    isLeagueMarketingPage,
    leagueInfoSuccessData,
    updateLeagueCode: (value) => setLeagueCode(value),
    updateCheckboxCheckedStates: (value) => setCheckboxCheckedStates(value),
    updateTriggerClassicPublicLeagueRefetch: (value) =>
      setTriggerClassicPublicLeagueRefetch(value),
    updateIsLeagueMarketingPage: (value) => setIsLeagueMarketingPage(value),
    updateLeagueInfoSuccessData: (value) => setLeagueInfoSuccessData(value),
  };

  return (
    <LeagueContext.Provider value={value}>{children}</LeagueContext.Provider>
  );
};

export default LeagueContextProvider;
